/* ++++++++++ --------------- CHECKLIST : STYLES --------------- ++++++++++ */
import {pxToEm} from "@insticator/insticator-ui";

export default {
    Checklist: {
        flex: '1',
        '& > .MuiList-root': {
            '& > .titlesection': {
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: pxToEm(12),
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                borderBottom: '1px solid #7E92B8',
                width: '100%',
                '& > .checklisttitle': {
                    color: '#061240',
                    fontFamily: 'Work Sans',
                    fontSize: pxToEm(16),
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                    flex : 1,
                    alignSelf: 'center'
                },
                '& > .disabled': {
                    opacity: 0.2,
                }
            },
            '& > .itemsection': {
                marginTop: pxToEm(9),
                '& > .MuiListItem-root': {
                    '& > .MuiButtonBase-root': {
                        '& > .listitem': {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: pxToEm(2),
                            '& > .disabled':{
                                opacity: 0.2,
                            },
                            '& > .listitemtext': {
                                '& > span': {
                                    color: '#061240 !important',
                                    'font-variant-numeric': 'lining-nums proportional-nums',
                                    'font-family': "Work Sans",
                                    fontSize: pxToEm(16),
                                    fontStyle: 'normal !important',
                                    fontWeight: 400,
                                    lineHeight: 'normal !important'
                                }
                            },
                            '& > .internal': {
                                marginTop: pxToEm(4),
                                color: '#F99D12',
                                'font-variant-numeric': 'lining-nums proportional-nums',
                                'font-family': "Work Sans",
                                fontSize: pxToEm(16),
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: 'normal'
                            }

                        }
                    }
                }
            }
        }


        },
}